import { Link } from "react-router-dom";
import { Instagram, Youtube } from "lucide-react";
import { Logo } from "./Logo";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/candles", label: "Candles" },
  { to: "/jewellery", label: "Jewellery" },
  { to: "/fashion", label: "Fashion" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const SOCIAL = [
  { label: "Instagram", href: "https://www.instagram.com/zelvoriaindia", icon: <Instagram size={16} strokeWidth={1.4} /> },
  { label: "YouTube", href: "https://www.youtube.com/@zelvoriaindia", icon: <Youtube size={16} strokeWidth={1.4} /> },
];

export const Footer = () => (
  <footer className="border-t border-beige bg-cream" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl items-center gap-10 px-6 py-16 md:grid-cols-3 md:px-10">
      <div className="flex flex-col items-center gap-4 md:items-start">
        <Logo variant="stacked" className="h-16" />
        <p className="text-[10px] uppercase tracking-[0.3em] text-taupe">Timeless Elegance. In Every Detail.</p>
      </div>
      <nav className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3" data-testid="footer-nav">
        {NAV.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            data-testid={`footer-nav-${item.label.toLowerCase()}`}
            className="text-[11px] uppercase tracking-[0.22em] text-ink transition-colors hover:text-gold"
          >
            {item.label}
          </Link>
        ))}
      </nav>
      <div className="flex items-center justify-center gap-3 md:justify-end">
        {SOCIAL.map((s) => (
          <a
            key={s.label}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={s.label}
            data-testid={`social-${s.label.toLowerCase()}`}
            className="flex h-10 w-10 items-center justify-center border border-cocoa/20 text-ink transition-colors duration-300 hover:border-gold hover:text-gold"
          >
            {s.icon}
          </a>
        ))}
      </div>
    </div>
    <div className="border-t border-beige/70">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-6 py-6 text-[11px] tracking-wider text-taupe md:flex-row md:px-10">
        <p>© 2026 Zelvoria. All rights reserved.</p>
        <p className="font-serif italic text-gold">Timeless Elegance. Always.</p>
      </div>
    </div>
  </footer>
);
